<p-dropdown (onChange)='onChange($event.value)' [ngModel]='selectedPriceId' [options]='priceIds'>
</p-dropdown>
